import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from '@/utils/redux';
import { setIsTrailMapOpen } from '@/utils/trailPageSlice';

export default function useIsTrailMapOpen() {
  const dispatch = useDispatch();
  const isTrailMapOpen = useSelector(state => state.trailPage.isTrailMapOpen);

  useEffect(() => {
    return () => {
      // When a component calling this hook is unmounted, close the trail map
      dispatch(setIsTrailMapOpen(false));
    };
  }, [dispatch]);

  const openTrailMap = useCallback(() => {
    dispatch(setIsTrailMapOpen(true));
  }, [dispatch]);

  return useMemo(() => ({ isTrailMapOpen, openTrailMap }), [isTrailMapOpen, openTrailMap]);
}
